import React from 'react'
import aboutImg from '../../images/aboutus.png'
import './aboutus.css'

const AboutUs = () => {
    return (
        <div class="about-container">
            <img src={aboutImg} alt="SuperCodingBits" />
            <div class="about-text">
                <p><strong> Hello learners, </strong></p>
                <p><strong>@SuperCodingBits</strong> is the perfect YouTube channel to learn how to develop stunning front-end UIs using React JS! Whether you're starting from scratch or already have some experience, we provide step-by-step guidance to help you build beautiful, responsive, and user-friendly interfaces. From creating reusable components and managing layouts with CSS to exploring advanced UI patterns, we cover everything you need to design modern, interactive web applications. Join us to master the art of front-end development and bring your creative ideas to life with React!</p>
            </div>
        </div>
    )
}

export default AboutUs